import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-switch-lang';
import { NavLink } from 'react-router-dom';

// STYLES
const FooterContainer = styled.footer`
  margin: 10rem 0 5rem 0;
`;

const StyledNavLink = styled(NavLink)`
  margin: 0 15px;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: bold;
  transition: all 0.2s;

  &:hover {
    text-decoration: none;
    color: ${ props => props.theme.color.secondary };
  }

  &.active {
    border-bottom: 2px solid ${props => props.theme.color.text.body};
  }
`;

// COMPONENT
const Footer = props => (
  <FooterContainer>
    <StyledNavLink to="/impressum-datenschutz">Impressum und Datenschutz</StyledNavLink>
  </FooterContainer>
);

export default translate(Footer);